import { render, staticRenderFns } from "./PersonSearch.vue?vue&type=template&id=da4edad2&scoped=true&"
import script from "./PersonSearch.vue?vue&type=script&lang=js&"
export * from "./PersonSearch.vue?vue&type=script&lang=js&"
import style0 from "./PersonSearch.vue?vue&type=style&index=0&id=da4edad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4edad2",
  null
  
)

export default component.exports